import mistyLawn from "./assets/misty-lawn.jpeg";
import cottagesRidge from "./assets/cottages-ridge.jpeg";
import valleyMist from "./assets/valley-mist.jpeg";
import verandahWalkway from "./assets/verandah-walkway.jpeg";
import redSteps from "./assets/red-steps.jpeg";

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_68cac0ea-3e93-4b2d-81e6-cc089545b3ba/artifacts/7onjvllk_WhatsApp%20Image%202026-07-11%20at%206.34.08%20PM%20%281%29.jpeg",
  mist: mistyLawn,
  dusk: "https://customer-assets.emergentagent.com/job_68cac0ea-3e93-4b2d-81e6-cc089545b3ba/artifacts/xa7rvtzm_WhatsApp%20Image%202026-07-11%20at%206.34.07%20PM%20%281%29.jpeg",
  cottages: "https://customer-assets.emergentagent.com/job_68cac0ea-3e93-4b2d-81e6-cc089545b3ba/artifacts/55wh8r9y_WhatsApp%20Image%202026-07-11%20at%206.34.07%20PM.jpeg",
  dog: "https://customer-assets.emergentagent.com/job_68cac0ea-3e93-4b2d-81e6-cc089545b3ba/artifacts/4gkhao3r_WhatsApp%20Image%202026-07-11%20at%206.34.08%20PM%20%282%29.jpeg",
  ridge: cottagesRidge,
  valley: valleyMist,
  walkway: verandahWalkway,
  steps: redSteps,
};

export const NAV_LINKS = [
  { label: "Story", href: "#story" },
  // Hidden for now — re-enable when the cottages section goes live again:
  // { label: "Cottages", href: "#cottages" },
  { label: "Moments", href: "#moments" },
  { label: "Amenities", href: "#amenities" },
  { label: "Stay", href: "#booking" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Where the fog lives",
    body: "Perched where the hills breathe cloud, Vistara sits quietly among bamboo groves and tea-estate greenery. Mornings arrive slow — mist rolling over ridgelines, birdsong instead of alarms.",
  },
  {
    no: "02",
    title: "Grounded, not gilded",
    body: "Red-oxide steps, whitewashed cottage walls, and warm string lighting at dusk. We kept it honest and handmade — the kind of place that feels lived-in the moment you arrive.",
  },
  {
    no: "03",
    title: "A slower rhythm",
    body: "No agenda but the weather. Bonfires after dark, trails before breakfast, and long verandah afternoons watching the valley change colour.",
  },
];

export const COTTAGES = [
  {
    name: "Mist Cottage",
    view: "Valley-facing",
    size: "1 King · 2 guests",
    amenities: "Private verandah · Hot water · Tea kit",
    tag: "Most loved",
  },
  {
    name: "Bamboo Cottage",
    view: "Forest edge",
    size: "1 King + Bunk · 3 guests",
    amenities: "Garden seating · Heater · Breakfast",
    tag: "Family",
  },
  {
    name: "Ridge Cottage",
    view: "Sunrise ridgeline",
    size: "2 Queen · 4 guests",
    amenities: "Corner deck · Fireplace view · Pet-friendly",
    tag: "Premium",
  },
];

export const AMENITIES = [
  { icon: "Mountain", title: "Mountain views", note: "Uninterrupted valley & ridgeline vistas." },
  { icon: "Flame", title: "Bonfire deck", note: "Evenings around warm, crackling fires." },
  { icon: "Footprints", title: "Nature trails", note: "Guided walks through bamboo & estate paths." },
  { icon: "Dog", title: "Pet-friendly", note: "Your companions are always welcome." },
  { icon: "Coffee", title: "Estate tea & meals", note: "Home-style food, fresh hill-grown tea." },
  { icon: "Wifi", title: "Connected, gently", note: "Wi-Fi where you want it, silence where you don't." },
  { icon: "Sunrise", title: "Sunrise verandahs", note: "Watch the cloud lift with your morning cup." },
  { icon: "Moon", title: "Star-lit nights", note: "Low light pollution, wide open skies." },
];

export const MARQUEE_WORDS = ["Breathe", "Unwind", "Disconnect", "Wander", "Belong"];

export const TESTIMONIALS = [
  {
    quote:
      "Great view, great food and great service. I went with my elderly parents and two kids — my little one is a very picky eater, but the food was absolutely delicious. The view was stunning. Highly recommend for a quiet and peaceful getaway.",
    name: "Kavya Deepthi",
  },
  {
    quote:
      "Surrounded by beautiful hills all around, it truly feels like a different world. The views are breathtaking and the atmosphere is calm and refreshing. If you're visiting Araku with friends, this is the best place to stay.",
    name: "Chaitanya P",
  },
  {
    quote:
      "A perfect place to relax and enjoy the pleasant climate. The food has a nostalgic touch that reminds you of home. The staff are friendly and welcoming, and the maintenance is excellent.",
    name: "Saigayathri Pothala",
  },
];

export const CONTACT = {
  name: "Vistara Resort and Homestay",
  phone: "+91 91138 21502",
  whatsapp: "919113821502",
  email: "vistaraaresort@gmail.com",
  instagram: "https://www.instagram.com/vistaraaresort/",
  facebook: "https://www.facebook.com/people/Vistara-Resorts/61550271389598/",
  address: "Vistara Resort and Homestay, Arku, Visakhapatnam, Andhra Pradesh 531149",
  mapEmbed:
    "https://www.openstreetmap.org/export/embed.html?bbox=82.9148%2C18.2433%2C82.9948%2C18.3033&layer=mapnik&marker=18.273255738363968%2C82.95480601035656",
};
